// extracted by mini-css-extract-plugin
module.exports = {"shp2-detail-I":"I_shp2-detail-I__rMpJ7"};